var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification)?_c('div',{class:_vm.classes},[_c('p',[_vm._v(_vm._s(_vm.notification.message))]),_vm._v(" "),_c('span',{staticClass:"btn btn-sm btn-secondary",on:{"click":_vm.cleanNotification}},[_vm._v(_vm._s(_vm.$t('close')))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f6935c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DxNotification.vue
// module id = null
// module chunks = 